// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-XE5DBE',
  builtAt: '2026-11-05T05:58:50.786Z'
};
